#import "../fragments/event-fragment-sparse.graphql"
#import "../fragments/pinned-info-fragment.graphql"

query GetKeyEvents($input: TimelineEventsKeyInput!) {
    keyEvents(input: $input) {
        edges {
            node {
                ...EventFragmentSparse
            }
            pinnedInfo {
                ...PinnedInfoFragment
            }
        }
    }
}
